export const RESILO = 'RESILO';
export const PFLEGERAT = 'PFLEGERAT';
